import { getJson } from './getJson/index.js';
import { postJson } from './postJson/index.js';
import { patchJson } from './patchJson/index.js';
import { deleteJson } from './deleteJson/index.js';
export { F as FetchHandlerStatusCode } from './chuck/fetchHandler-BmcM6Yrg.js';

var ULRequest = {
    getJson: getJson,
    postJson: postJson,
    patchJson: patchJson,
    deleteJson: deleteJson
};

export { ULRequest };
